module.exports = "https://www.gc-qa.gnp.com.mx/4204cf348c9fbf9080839a28fae769d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/registro/6.png
// module id = 1055
// module chunks = 0 1